import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
const images = ['https://cdn.magicpatterns.com/uploads/kpoXn7PSmRXpLTLEpQaajP/IMG_6885.jpg', 'https://cdn.magicpatterns.com/uploads/3D2ric32tiHY4Yu7va8ueX/IMG_6886.png', 'https://cdn.magicpatterns.com/uploads/d6NL9UKyPTLi6nihCSKtTQ/IMG_6887.png'];
export function Gallery() {
  const {
    t
  } = useLanguage();
  return <section className="py-24 md:py-32 bg-ink" data-id="element-119">
      <div className="max-w-7xl mx-auto px-6 lg:px-10" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-121">
          <p className="text-gold text-xs tracking-[0.3em] mb-4" data-id="element-122">
            {t('gallery.eyebrow')}
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-cream leading-tight" data-id="element-123">
            {t('gallery.title.1')}{' '}
            <span className="italic gold-text" data-id="element-124">{t('gallery.title.2')}</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-125">
          {images.map((src, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className={`overflow-hidden ${i === 0 ? 'col-span-2 row-span-2' : ''}`} data-id="element-126">
              <img src={src} alt={`Jade ${i + 1}`} className={`w-full object-cover hover:scale-105 transition-transform duration-700 ${i === 0 ? 'h-full min-h-[300px] md:min-h-[520px]' : 'h-48 md:h-64'}`} data-id="element-127" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}